'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'swords-laser';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e03d';
var svgPathData = ['M51.3-12.6c3-3 7.7-3.1 10.8-.3L374.7 272 295.2 272 51-1.9c-2.8-3.1-2.6-7.8 .3-10.7zM361.4 157.1L376 170.3 578.1-12.9c3.1-2.8 7.8-2.7 10.7 .3s3 7.6 .3 10.7l-182 200.6 13.5 12.3-.3 .3-59.1-54 .3-.2z', 'M35.4 454.1L202.6 286.8c-.5 15.1 4.9 30.8 17.7 43.6l56 56-154.3 154.3c-18.7 18.7-49.1 18.7-67.9 0L35.4 521.9c-18.7-18.7-18.7-49.1 0-67.9zM612.7 19.5L430.7 220.2 407.1 198.6 589-2c2.8-3.1 2.7-7.8-.3-10.7s-7.6-3-10.7-.3L376 170.3 352.2 148.7 556.6-36.7c15.7-14.2 39.8-13.7 54.8 1.3S627 3.8 612.7 19.5zM192.1 342.6l-25.4 25.4 41.4 41.4 25.4-25.4-41.4-41.4zM185.4 432L144.1 390.6 58 476.7c-6.2 6.2-6.2 16.4 0 22.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0L185.4 432zM51.3-12.6C48.4-9.7 48.2-5 51-1.9L295.2 272 374.7 272 62.1-12.9c-3.1-2.8-7.9-2.7-10.8 .3zM83.7-36.5l338.6 308.5 12.6 0c8.5 0 16.6 3.4 22.6 9.4L606.1 430.1c18.7 18.7 18.7 49.1 0 67.9L562 542.1c-18.7 18.7-49.1 18.7-67.9 0L251.4 299.3c-7.8-7.8-5.3-20 3-25L27.1 19.4c-14.1-15.8-13.4-39.7 1.6-54.7 15-15 39.3-15.6 55-1.3zM583.5 475.3c6.2-6.2 6.2-16.4 0-22.6l-74.7-74.7-22.1 22.1 86.1 86.1 10.7-10.7zm-44.1 44.1l10.7-10.7-86.1-86.1-22.1 22.1 74.7 74.7c6.2 6.2 16.4 6.2 22.6 0zm-120-97.4l66.7-66.7-51.3-51.3-133.5 0 118.1 118.1z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSwordsLaser = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;